/* eslint-disable @typescript-eslint/no-explicit-any */
import {useRoute} from '@react-navigation/native';
import React from 'react';
import {Image, Platform, Text, View} from 'react-native';
import {connect} from 'react-redux';

import iconeAirtel from '../../../ressources/images/iconPaiement/airtel-money.png';
import iconetelma from '../../../ressources/images/iconPaiement/mvola.png';
import iconeOrange from '../../../ressources/images/iconPaiement/orange-money.png';
import iconeVisa from '../../../ressources/images/iconPaiement/visa.png';
import mapDispatchToProps from '../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../services/redux/mapStateToProps';
import {HeaderScreen} from '../../components/Header/HeaderScreen';

const NewFeaturesFC = () => {
  const {params}: any = useRoute();

  const statusIcone: any = {
    telma: iconetelma,
    airtel: iconeAirtel,
    orange: iconeOrange,
    bank: iconeVisa,
  };

  return (
    <View style={{flex: 1}}>
      <HeaderScreen
        title={'Nouvelle fonctionalité'}
        type="retour"
        noBreadcrumb={false}
      />
      <View
        style={{
          flex: 1,
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: 40,
        }}>
        <Image
          source={
            params?.type &&
            (params.type === 'telma' ||
              params.type === 'airtel' ||
              params.type === 'bank' ||
              params.type === 'orange') &&
            statusIcone[params.type]
              ? statusIcone[params.type]
              : // eslint-disable-next-line @typescript-eslint/no-require-imports
                require('../../../ressources/images/IconMonEspace/ShieldFail.png')
          }
          style={Platform.OS === 'web' ? {width: 125, height: 125} : {}}
        />
        <Text style={{fontSize: 20}}>
          {params?.text
            ? params.text
            : `Cette fonctionalité sera disponible prochainement !`}
        </Text>
      </View>
    </View>
  );
};

export const NewFeatures: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewFeaturesFC);

export default NewFeatures;
